const statusOptions = [
    { value: "Comercialização", label: "Comercialização", },
    { value: "Esgotado", label: "Esgotado" },
    { value: "Futuro", label: "Futuro" },
    { value: "Suspenso", label: "Suspenso" },
];

const genreOptions = [
    { value: "Feminino", label: "Feminino" },
    { value: "Masculino", label: "Masculino" },
    { value: "Outros", label: "Outros" },
];

const userTypeOptions = [
    { value: "lead", label: "Lead" },
    { value: "visitante", label: "Visitante" },
    { value: "cliente", label: "Cliente" },
];

const maritalStatusOptions = [
    { value: "Casado", label: "Casado(a)" },
    { value: "Divorciado", label: "Divorciado(a)" },
    { value: "Separado", label: "Separado(a)" },
    { value: "Solteiro", label: "Solteiro(a)" },
    { value: "Viúvo", label: "Viúvo(a)" },
];

const childrenOptions = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5+' },
];
const dormitorios = [1, 2, 3, 4];

const ageOptions = [
    ...Array.from({ length: 81 }, (_, i) => ({ value: i + 18, label: String(i + 18) })),
    { value: 99, label: '99+' }
];

export  { statusOptions, genreOptions, userTypeOptions, maritalStatusOptions, childrenOptions, dormitorios , ageOptions};